const CategoryFilter = ({ categories, selectedCategory, setSelectedCategory, styles, theme }) => {
  return (
    <div style={styles.card1}>
      <div style={styles.categoryFilter}>
        {categories.map((category) => {
          const CategoryIcon = category.icon;
          const isActive = selectedCategory === category.id;

          return (
            <div
              key={category.id}
              style={styles.categoryItem(isActive)}
              onClick={() => setSelectedCategory(category.id)}
              onMouseEnter={(e) => {
                if (!isActive) {
                  e.currentTarget.style.transform = "translateY(-3px)";
                  e.currentTarget.style.boxShadow =
                    theme === "dark"
                      ? "0 8px 24px rgba(0, 0, 0, 0.3)"
                      : "0 8px 24px rgba(0, 0, 0, 0.1)";
                }
              }}
              onMouseLeave={(e) => {
                if (!isActive) {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow =
                    theme === "dark"
                      ? "0 4px 12px rgba(0, 0, 0, 0.2)"
                      : "0 4px 12px rgba(0, 0, 0, 0.06)";
                }
              }}
            >
              <CategoryIcon size={20} />
              {category.name}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CategoryFilter;